<template>
  <div class="h-full">
    <div class="flex flex-wrap mb-10px mr-10px">
      <el-input
        size="small"
        class="mr-10px !w-50 mb-10px"
        placeholder="请输入姓名"
        maxlength="50"
        v-model="searchData.name"
        clearable
      ></el-input>

      <el-button size="small" type="primary" @click="searchList()">搜索</el-button>
      <el-button size="small" @click="resetSearch()">重置</el-button>
      <el-button size="small" type="primary" @click="addWorkLeaderPersonal()">添加</el-button>
    </div>
    <el-table
      :data="workLeaderpersonalData"
      border
      stripe
      :height="tableHeight"
      v-if="tableLoading"
      class="overflow-hidden"
    >
      <el-table-column type="index" label="序号" width="60" show-overflow-tooltip></el-table-column>
      <el-table-column label="姓名" prop="name" show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="item.displayName"
        :prop="`key${item.code}${index}`"
        show-overflow-tooltip
        v-for="(item, index) in certificateCategoryList"
        :key="item.code"
        min-width="80"
      >
        <template slot-scope="scope">
          {{ scope.row[`key${item.code}${index}`] ? '√' : '/' }}
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="180" class="top-43px">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleEvent('edit', scope.row)"
            >编辑</el-button
          >
          <el-button size="mini" type="danger" @click="handleEvent('delete', scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      @size-change="workLeaderpersonalTableSizeChange"
      @current-change="workLeaderpersonalableCurrentChange"
      :current-page.sync="workLeaderpersonalPageConfig.SkipCount"
      :page-size.sync="workLeaderpersonalPageConfig.MaxResultCount"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
      :total="workLeaderpersonalPageConfig.total"
      class="float-right mt-20px ml-20px clear-both"
    ></el-pagination>
    <el-dialog
      :title="title"
      :visible.sync="addWorkLeaderPersonalVisible"
      class="small-dialog"
      v-dialogDrag
      :before-close="cancel"
      append-to-body
      :close-on-click-modal="false"
    >
      <el-form ref="workLeaderpersonalRef" label-width="150px" :model="workLeaderpersonalForm">
        <el-form-item
          label="工作负责人"
          prop="userId"
          :rules="[
            {
              required: true,
              message: '请输入工作负责人',
              trigger: ['blur', 'change'],
            },
          ]"
        >
          <el-select
            v-model="workLeaderpersonalForm.userId"
            class="w-full"
            placeholder="请选择"
            clearable
            filterable
            @change="changeSelectName"
          >
            <el-option
              v-for="(item, index) in allUserList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="作业资质具备情况"
          prop="certificateCodes"
          :rules="[
            {
              required: true,
              message: '请输入作业资质具备情况',
              trigger: ['blur', 'change'],
            },
          ]"
        >
          <el-select
            v-model="workLeaderpersonalForm.certificateCodes"
            size="small"
            placeholder="请选择作业资质具备情况"
            clearable
            multiple
          >
            <el-option
              v-for="item in certificateCategoryList"
              :key="item.value"
              :label="item.displayName"
              :value="Number(item.code)"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="flex justify-center">
        <el-button size="small" type="primary" @click="save" :loading="loading">保存</el-button>
        <el-button size="small" @click="cancel">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { EafOrganizationUnitUserApi } from '@wiz-api/account'
import { ContractorApi } from '@wiz-api/contractor-management'
import utils from '@/components/safety/enumField/utils'

const contractorApi = new ContractorApi()
const eafOrganizationUnitUserApi = new EafOrganizationUnitUserApi()
export default {
  props: {
    contractorId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      tableLoading: false,
      title: '添加',
      saveWorkLeaderRow: {},
      allUserList: [],
      loading: false,
      workLeaderpersonalForm: {
        certificateCodes: [],
      },
      addWorkLeaderPersonalVisible: false,
      workLeaderpersonalData: [],
      workLeaderpersonalPageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
        total: 0,
      },
      searchData: {
        name: '',
      },
      certificateCategoryList: [],
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 107px)'
    },
  },
  async created() {
    this.tableLoading = true
    this.getAllUserList()
    await utils.getDataCategory(
      ['ContractorManagement.DataCategory.CertificateCategory'],
      ['certificateCategoryList'],
      this
    )
    this.getData()
  },
  methods: {
    searchList() {
      this.workLeaderpersonalPageConfig.SkipCount = 1
      this.getData()
    },
    resetSearch() {
      this.searchData.name = ''
      this.workLeaderpersonalPageConfig.SkipCount = 1
      this.getData()
    },
    handleEvent(type, row) {
      if (type === 'edit') {
        this.title = '编辑'
        this.addWorkLeaderPersonalVisible = true
        // this.saveWorkLeaderRow = JSON.parse(JSON.stringify(row))
        this.workLeaderpersonalForm = JSON.parse(JSON.stringify(row))
      } else {
        this.$confirm('请确认是否删除？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const [err, res] = await contractorApi.deleteWorkPersonInCharge(
              this.contractorId,
              row.id
            )
            if (!err) {
              this.$message.success('删除成功')
              this.getData()
            }
          })
          .catch(() => {})
      }
    },
    changeSelectName(val) {
      const user = this.allUserList.find((item) => {
        return item.id === val
      })
      this.workLeaderpersonalForm.name = user.name
    },
    async getAllUserList() {
      const [err, res] = await eafOrganizationUnitUserApi.getOrganizationUnitUserList({
        maxResultCount: 999,
        skipCount: 1,
        organizationUnitId: undefined,
        includeOrgChild: true,
        userName: '',
        sorting: '',
      })
      if (!err) {
        this.allUserList = res.items
      }
    },
    async getData() {
      const data = {
        name: this.searchData.name,
        maxResultCount: this.workLeaderpersonalPageConfig.MaxResultCount, // 每页多少条
        skipCount:
          (this.workLeaderpersonalPageConfig.SkipCount - 1) *
          this.workLeaderpersonalPageConfig.MaxResultCount, // 跳过多少条
      }
      const [err, res] = await contractorApi.getWorkPersonInChargeByPage(this.contractorId, data)
      if (!err) {
        this.workLeaderpersonalData = res.items.map((item) => {
          this.certificateCategoryList.forEach((category, categoryIndex) => {
            if (item.certificateCodes.includes(parseInt(category.code, 10))) {
              item[`key${category.code}${categoryIndex}`] = true
            } else {
              item[`key${category.code}${categoryIndex}`] = false
            }
          })
          return item
        })
        this.workLeaderpersonalPageConfig.total = res.totalCount
      }
    },
    // 奖励考核信息页码改变
    workLeaderpersonalTableSizeChange(MaxResultCount) {
      this.rewardsAndAssessment.MaxResultCount = MaxResultCount
      this.getData()
    },
    // 奖励考核信息页数改变
    workLeaderpersonalableCurrentChange(SkipCount) {
      this.rewardsAndAssessmentPageConfig.SkipCount = SkipCount
      this.getData()
    },
    addWorkLeaderPersonal() {
      this.title = '添加'
      this.addWorkLeaderPersonalVisible = true
    },
    cancel() {
      this.$refs.workLeaderpersonalRef.resetFields()
      this.addWorkLeaderPersonalVisible = false
      this.workLeaderpersonalForm = {}
    },
    save() {
      this.$refs.workLeaderpersonalRef.validate(async (valid) => {
        if (valid) {
          this.loading = true
          if (!this.workLeaderpersonalForm.id) {
            const [err, res] = await contractorApi.createWorkPersonInCharge(this.contractorId, {
              body: this.workLeaderpersonalForm,
            })
            if (!err) {
              this.$message.success('保存成功')
              this.cancel()
              this.getData()
            }
          } else {
            const [err, res] = await contractorApi.updateWorkPersonInCharge(
              this.contractorId,
              this.workLeaderpersonalForm.id,
              {
                body: this.workLeaderpersonalForm,
              }
            )
            if (!err) {
              this.$message.success('编辑成功')
              this.cancel()
              this.getData()
            }
          }
          this.loading = false
        } else {
          this.loading = false
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-table__fixed-right {
  height: 100% !important;
}
</style>
